/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum Roles {
  $1 = 1,
  $2 = 2
}
